import { confirmKycFile } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useKycFileConfirmation = () => {
	const tInvestor = useTranslationInvestor();
	const confirmMutation = useMutation({ mutationFn: (id: string) => confirmKycFile(id) });

	const createConfirmHandler = useCallback(
		(fileId: string | undefined, refetch: () => void) => () => {
			if (!fileId) {
				return;
			}
			confirmMutation.mutate(fileId, {
				onSuccess: () => {
					showToastV2({ title: tInvestor('investment.join.kyc.inherited.confirmed') });
					refetch();
				},
			});
		},
		[confirmMutation, tInvestor]
	);

	return { confirmMutation, createConfirmHandler };
};
